import React from 'react';
import {Dropdown} from 'react-bootstrap';

export default function ActionDropdownButton({config, className}) {
  const {main, dropdown = []} = config;
  const dropdownClassName = className || 'btn-group';

  return (
    <Dropdown as="div" className={dropdownClassName}>
      {dropdown.length > 0 && (
        <>
          <Dropdown.Toggle id="dropdown-split-button" className="btn-success">
            {main.label}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {dropdown.map((item, index) => {
              return (
                <Dropdown.Item key={index} onClick={item.onClick}>
                  {item.label}
                </Dropdown.Item>
              );
            })}
          </Dropdown.Menu>
        </>
      )}
    </Dropdown>
  );
}
